<template>
    <div class="form-advanced-filter">
        <div class="date-filters">
            <form-date label="Date start" v-model="internalValue.dateFilter.start_at" format="yyyy-MM-dd"></form-date>
            <form-date label="Date end" v-model="internalValue.dateFilter.end_at" format="yyyy-MM-dd"></form-date>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AdvancedFilter',
    props: ['value','activeDate'],
    components: {  },
    data: function () {
        return {
            internalValue: {
                dateFilter: {
                    start_at: null,
                    end_at: null
                }
            },
            activeDateVue: null
        }
    },
    created: function() {
        this.internalValue = this.value;
        this.activeDateVue = this.activeDate && (this.activeDate == 'true' || this.activeDate == true) ? true : false;
    },
    methods: {
    },
    watch: {
    }
}

</script>


// WEBPACK FOOTER //
// src/components/AdvancedFilters.vue